<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "PageIndex",
    created() {
        this.$store.dispatch('getPages');
    }
}
</script>

<style>
#dashboard_nav {
    display: block;
}
#dashboard_content {
    width:75%;
    -webkit-box-flex: 0;
    flex: 0 0 75%;
    max-width: 75%;
}
</style>